import React from "react";
import PropTypes from "prop-types";

const Vision = ({ vision, onSelectVendedor }) => {
  const getColor = (valor) => {
    if (valor < 200) return "text-red-600";
    if (valor <= 300) return "text-yellow-500";
    return "text-green-600";
  };

  return (
    <div className="w-full mt-4 bg-white shadow-md rounded-lg overflow-hidden border border-gray-200">
      <table className="w-full text-sm text-gray-700 table-fixed">
        <thead className="bg-[#01054C] text-white text-left">
          <tr>
            <th className="px-5 py-3 font-semibold rounded-tl-lg">Pontuação Total</th>
            <th className="px-5 py-3 font-semibold text-center">Ating. Real (pts)</th>
            <th className="px-5 py-3 font-semibold text-center rounded-tr-lg">
              Ating. Proj. (pts)
            </th>
          </tr>
        </thead>
        <tbody>
          {vision.map((pessoa, i) => {
            const real = Number(pessoa.real || 0);
            const proj = Number(pessoa.proj || 0);
            const campanha = Number(pessoa.campanha || 0);


            const realFinal = real > 0 ? Math.min(real + campanha, 500) : real;
            const projFinal = proj > 0 ? Math.min(proj + campanha, 500) : proj;

            return (
              <tr
                key={i}
                className={`border-t border-gray-100 hover:bg-slate-50 transition-colors ${
                  i % 2 === 0 ? "bg-white" : "bg-slate-50/40"
                }`}
              >
                <td className="px-5 py-3 text-primaria">
                  {onSelectVendedor ? (
                    <button
                      type="button"
                      onClick={() => onSelectVendedor(pessoa)}
                      className="text-left font-medium underline-offset-2 hover:underline focus:outline-none focus:underline"
                    >
                      {pessoa.nome}
                    </button>
                  ) : (
                    pessoa.nome
                  )}
                </td>

                <td
                  className={`px-5 py-3 text-center font-medium ${getColor(
                    realFinal
                  )}`}
                >
                  {realFinal.toLocaleString("pt-BR")} pts
                </td>

                <td
                  className={`px-5 py-3 text-center font-medium ${getColor(
                    projFinal
                  )}`}
                >
                  {projFinal.toLocaleString("pt-BR")} pts
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

Vision.propTypes = {
  vision: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      nome: PropTypes.string.isRequired,
      real: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      proj: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      campanha: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ).isRequired,
  onSelectVendedor: PropTypes.func,
};

export default Vision;
